import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import { Grid, Alert } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { postData } from "../../services/Request";
import CircularProgress from "@mui/material/CircularProgress";
import S1 from "../../assets/ContactUs/S1.jpg";
import logo from "../../assets/Header/logo3.png";
import "../../styles/SignUp.css";

export default function InstructorSignUp() {
  const nav = useNavigate();

  const [alertMessage, setAlertMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [loader, setLoder] = useState(false);
  const [agree, setAgree] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    var details = {
      firstname: e.target.firstname.value,
      lastname: e.target.lastname.value,
      email: e.target.email.value,
      password: e.target.password.value,
      confirm_password: e.target.confirm_password.value,
    };
    if (details.firstname.trim() === "") {
      setAlertMessage("Input your first name");
      setSeverity("warning");
    } else if (details.lastname.trim() === "") {
      setAlertMessage("Input your last name");
      setSeverity("warning");
    } else if (details.email.trim() === "") {
      setAlertMessage("Input your email");
      setSeverity("warning");
    } else if (details.password.trim() !== details.confirm_password.trim()) {
      setAlertMessage("Passwords do not match");
      setSeverity("warning");
    } else {
      setLoder(true);
      setAlertMessage("");
      postData("instuctorsignup", details)
        .then((response) => {
          setLoder(false);
          if (response.status === true) {
            setAlertMessage(response.message);
            setSeverity("success");
            nav("/teacherlogin");
          } else {
            setAlertMessage(response.message);
            setSeverity("error");
          }
        })
        .catch((error) => {
          setLoder(false);
          if (error.request.status === 422) {
            setAlertMessage(error.response.data.errors.email);
            setSeverity("error");
          } else if (error.request.status === 500) {
            setAlertMessage(
              "Connection to internet lost, please check connection and retry"
            );
            setSeverity("error");
          } else {
            setAlertMessage("Error creating account");
            setSeverity("error");
          }
        });
    }
  };

  const handleAgreeChange = (event) => {
    setAgree(event.target.checked);
  };

  return (
    <div className="SignUp-container">
      <div style={{ padding: "25px" }}>
        <div className="img-mobile">
          <img src={logo}></img>
        </div>
        <div className="img-box">
          <img
            src={S1}
            className="signup-img"
            style={{ borderRadius: "22px" }}
          ></img>
        </div>
        <div className="form-box">
          <Container component="main" maxWidth="xs">
            {alertMessage && (
              <Alert variant="filled" severity={severity}>
                {alertMessage}
              </Alert>
            )}
            <Box
              sx={{
                marginTop: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography sx={{ fontSize: "32px", fontWeight: "700" }}>
                Sign Up Instructor
              </Typography>

              <Box
                component="form"
                onSubmit={handleSubmit}
                noValidate
                sx={{ mt: 1 }}
              >
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="firstname"
                  label="First Name"
                  name="firstname"
                  autoFocus
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="lastname"
                  label="Last Name"
                  name="lastname"
                  autoFocus
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  autoFocus
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="password"
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="confirm_password"
                  label="Confirm Password"
                  type="password"
                  id="confirm_password"
                  autoComplete="confirm_password"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={agree}
                      onChange={handleAgreeChange}
                      color="primary"
                    />
                  }
                  label="I agree to the Terms & Conditions"
                />
                {loader === false && (
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    disabled={!agree}
                    sx={{
                      mt: 3,
                      mb: 2,
                      backgroundColor: "#006D34",
                      "&:hover": {
                        backgroundColor: "#45a049",
                      },
                    }}
                  >
                    Create an Account
                  </Button>
                )}
                {loader === true && (
                  <Button fullWidth variant="outlined">
                    <CircularProgress />
                  </Button>
                )}

                <Grid container>
                  <Grid item>
                    Already have an account?
                    <Link href="teacherlogin" variant="body2">
                      {"Login"}
                    </Link>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Container>
        </div>
      </div>
    </div>
  );
}
